import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';
import '../../styles/style.css';


function Disconnect({}) {
    const { t } = useTranslation();

    return (
        <div className={'disconnect-wrapper'}>
            <div className={'disconnect-container'}>
                <div className={'disconnect-icon'}></div>
                <div className={'disconnect-alert-wrapper'}>
                    <div className={'disconnect-alert-text'}>
                        {t("disconnect_text")}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Disconnect;